import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// Assets
import fileTypeDocIcon from '../../../../../assets/images/doc-default.png';
import fileTypeDocBlueIcon from '../../../../../assets/images/doc-blue.png';
import fileTypePdfBlueIcon from '../../../../../assets/images/pdf-blue.png';
import fileTypePdfIcon from '../../../../../assets/images/pdf-default.png';
import fileTypeXlsBlueIcon from '../../../../../assets/images/xls-blue.png';
import fileTypeXlsIcon from '../../../../../assets/images/xls-default.png';
// Components
import BaseComponent from '../../../../../baseClasses/BaseComponent';
import Animate from '../../../../../components/Animate';
import TaskCompletionStepComments from '../../../../../components/TaskCompletionStepsMobile/TaskCompletionStepComments';
// TODO: collapse <MiscUpload>, <Checkoff>, and <Inspection> web/mobile components
import Checkoff from '../../../../../components/TaskCompletionStepsMobile/Checkoff';
import Inspection from '../../../../../components/TaskCompletionStepsMobile/Inspection';
import CommentPopup from '../../../../../components/TaskCompletionStepsMobile/CommentPopup';
import PhotoUpload from '../../../../../components/TaskCompletionStepsMobile/PhotoUpload';
import MiscUpload from '../../../../../components/TaskCompletionStepsMobile/MiscUpload';
import StepApproval from '../../../../../components/TaskCompletionStepsMobile/StepApproval';
import FormUpload from '../../../../../components/Forms/FormUpload';
// Utils
import AnalyticsLogger from '../../../../../helpers/analytics/analyticsLogger';
import dataModel from '../../../../../models/DataModel';

import completedAudio from '../../../../../assets/audio/TaskStatusCompleted.mp3';
import pendingApprovalAudio from '../../../../../assets/audio/TaskStatusPendingApproval.mp3';
import pendingReviewAudio from '../../../../../assets/audio/TaskStatusPendingReview.mp3';
import './TaskCompletionStepInfoMobile.scss';
import Textarea from '../../../../../components/Textarea';

/**
 * Completion step info for MOBILE
 * TODO: collapse this with <TaskCompletionStepInfo> (web component)
 */
class TaskCompletionStepInfoMobile extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      stepState: '',
    };
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: true,
    });
    this.announceTaskStatus = this.announceTaskStatus.bind(this);
    this.checkSwitchCS = this.checkSwitchCS.bind(this);
  }

  setFocus(element) {
    if (element) {
      this.commentInput = element;
      element.focus();
    }
  }

  handleCommentsButton() {
    this.props.history.push(
      `/mobile/projects-tasks/task/${this.props.task.id}/completion_step/${
        this.props.completionStep.id
      }/comments`
    );
  }

  handleNoPhotoRequiredButton() {
    this.setState({ noPhotoRequiredComment: true });
  }

  handleKeyDown(e, type) {
    if (e.keyCode == 27) {
      this.setState({ noPhotoRequiredComment: false, rejectionComment: false });
    } else if (e.keyCode == 13 || e.keyCode == 40) {
      e.preventDefault();
      this.setState({ noPhotoRequiredComment: false, rejectionComment: false });

      const { completionStep } = this.props;
      if (this.state.commentText) {
        if (completionStep) {
          if (type == 'na') {
            completionStep.not_applicable = true;
            completionStep.completed_at = new Date().toJSON();
            dataModel.completionCriteriaDAO.update(completionStep);
          } else if (type == 'reject') {
            dataModel.completionCriteriaDAO.rejectCompletionCriterion(completionStep, this.state.commentText);
          }
          dataModel.commentsDAO.createComment({
            caption: type == 'qa' ? 'NO PHOTO REQUIRED' : 'REJECTED',
            body: this.state.commentText,
            commentable_type: 'CompletionCriterion',
            commentable_id: completionStep.id,
            user_id: this.props.currentUser.id,
          }, false, null, { recordDescriptor: { comments: {} } });
          this.setState({ commentText: '' });
          this.props.history.push(
            '/mobile/projects-tasks/task/' + this.props.task.id
          );
        }
      }
      if (this.commentInput) {
        this.commentInput.blur();
      }
    }
  }

  checkSwitchCS(goToNextCS) {
    if (!this.props.switchCS(goToNextCS) && goToNextCS) {
      this.handleHandsFreeTaskComplete();
    }
  }

  handleHandsFreeTaskComplete() {
    this.props.history.push({
      pathname: '/mobile/projects-tasks/task/' + this.props.task.id,
    });
    this.announceTaskStatus();
  }

  announceTaskStatus() {
    const { task } = this.props;
    let statusAudio = completedAudio;
    if (task.has_reviewer) {
      statusAudio = pendingReviewAudio;
    }
    else if (task.has_approver) {
      statusAudio = pendingApprovalAudio;
    }
    const statusAudioObject = new Audio(statusAudio);
    statusAudioObject.play();
  }

  handleCommentChange(e) {
    this.setState({ commentText: e.target.value });
  }

  handleCloseUpLoadButtons() {
    this.setState({ displayUploadButtons: false, hideUploadButtons: false });
  }

  handleCancelButton() {
    this.setState({
      hideUploadButtons: true,
    });
  }

  handleStepApprove() {
    const { userStepPermissions } = this.props;
    const { completionStep } = this.props;
    if (userStepPermissions.has('is_approver')) {
      this.handleApproved(completionStep);
    }
    else if (userStepPermissions.has('is_reviewer')) {
      this.handleReviewed(completionStep);
    }
  }

  handleStepReject() {
    const { userStepPermissions, task } = this.props;
    if (userStepPermissions.has('accept/reject')) {
      if((task.has_reviewer && this.props.completionStep.reviewed_at) || !task.has_reviewer){
        this.handleRejectApproval(this.props.completionStep);
      }
      else{
        this.handleRejectReview(this.props.completionStep);
      }
    }
  }

  handlePhotoSelection(val) {
    this.setState({ photoSelected: val });
  }

  handleReviewed(completionStep) {
    completionStep.reviewed_at = new Date().toJSON();
    this.analyticsLogger.logReviewEvent();
    dataModel.completionCriteriaDAO.reviewCompletionCriterion(completionStep);
    this.props.history.push('/mobile/projects-tasks/task/' + this.props.task.id);
  }

  handleRejectReview(completionStep) {
    this.setState({ rejectionComment: true });
  }

  handleApproved(completionStep) {
    if (completionStep) {
      completionStep.task_id = this.props.task.id;
      completionStep.approved_at = new Date().toJSON();
      this.analyticsLogger.logApprovalEvent();
      dataModel.completionCriteriaDAO.approveCompletionCriterion(completionStep);
      this.props.history.push('/mobile/projects-tasks/task/' + this.props.task.id);
    }
  }

  handleRejectApproval(completionStep) {
    this.setState({ rejectionComment: true });
  }

  handleCancelComment() {
    this.setState({
      rejectionComment: false,
    });
  }

  handleRejectionCommentSent(type, commentText) {
    this.setState({ rejectionComment: false });

    const { completionStep } = this.props;
    
    this.analyticsLogger.logRejectionEvent();
    const rejectionComment = commentText || this.state.commentText;
    dataModel.completionCriteriaDAO.rejectCompletionCriterion(completionStep, rejectionComment);
    
    if (this.state.rejectionComment) {
      dataModel.commentsDAO.createComment({
        caption: 'REJECTED',
        body: this.state.commentText,
        commentable_type: 'CompletionCriterion',
        commentable_id: completionStep.id,
        user_id: this.props.currentUser.id,
      }, false, null, { recordDescriptor: { comments: {} } });
      this.setState({ commentText: '' });
    }
    if (this.commentInput) {
      this.commentInput.blur();
    }
  }

  fixExtension(extension) {
    if (extension) {
      let markStart = extension.indexOf('?');
      if (markStart >= 0) {
        extension = extension.substring(0, markStart);
      }
    }
    return extension;
  }

  handleDetermineRejected(task) {
    if (!task.completion_criteria) {
      return false;
    }
    else { 
      const stepsRejected = task.completion_criteria.filter(cc => {
        if (cc) {
          return (cc.rejected_at && !cc.approved_at && !cc.reviewed_at && !cc.completed_at);
        }
        return false;
      });
      return stepsRejected.length > 0;
    }
  }

  getDocIcon(extension, isStepComplete) {
    switch (extension) {
    case 'pdf':
      return (isStepComplete ? fileTypePdfBlueIcon: fileTypePdfIcon);
    case 'xls':
    case 'xlt':
    case 'xlm':
    case 'xlsm':
    case 'xlsx':
    case 'xltx':
      return (isStepComplete ? fileTypeXlsBlueIcon: fileTypeXlsIcon);
    case 'doc':
    case 'docx':
    case 'dotx':
    case 'dot':
    case 'dotm':
    default:
      return (isStepComplete ? fileTypeDocBlueIcon: fileTypeDocIcon);
    }
  }

  render() {
    const { 
      editing, 
      task, 
      completionStep, 
      project, 
      userStepPermissions, 
    } = this.props;

    if (!task) {
      return null;
    }

    let buttons = [];

    let reviewApproveButtons;

    if (this.props.mobileBridge.isMobile) {
      buttons.push(
        <div
          key="comment-button"
          className="button comments-button"
          onClick={this.handleCommentsButton}
        >
          {completionStep.comments.length > 0 && (
            <div className="indicator-dot" />
          )}
        </div>
      );
    }

    if (userStepPermissions && userStepPermissions.has('accept/reject') && !completionStep.rejected_at) {
      reviewApproveButtons = (
        <div className="mobile-approve-reject-buttons">
          <StepApproval key={(task.has_reviewer && (userStepPermissions.has('is_reviewer') || this.props.currentUser.super_admin) &&
            !completionStep.reviewed_at ? '_review' : '_approve') + completionStep.id} userStepPermissions={userStepPermissions}
            handleStepReject={this.handleStepReject}
            handleStepApprove={this.handleStepApprove}
          />
        </div>
      );
    }

    let addIn = '';
    let typeImage = null;
    let webInstructions = null;
    if (completionStep.completion_type == 'boolean') {
      buttons = [];
      reviewApproveButtons = null;
      typeImage = (
        <Checkoff
          completionStep={completionStep}
          editing={editing}
          task={task}
          userStepPermissions={userStepPermissions}
          permissions={this.props.permissions}
          dataModel={this.props.dataModel}
          handleCommentsButton={this.handleCommentsButton}
          switchCS={this.checkSwitchCS}
          handleHandsFreeTaskComplete={this.handleHandsFreeTaskComplete}
          handleChildCompletionStepUpdate={this.props.handleChildCompletionStepUpdate}
        />
      );
    }
    else if (completionStep.completion_type == 'inspection') {
      reviewApproveButtons = null;
      typeImage = (
        <Inspection
          completionStep={completionStep}
          editing={editing}
          task={task}
          userStepPermissions={userStepPermissions}
          permissions={this.props.permissions}
          dataModel={this.props.dataModel}
          handleCommentsButton={this.handleCommentsButton}
          completionStepStatus={this.props.completionStepStatus}
          handleChildCompletionStepUpdate={this.props.handleChildCompletionStepUpdate}
        />
      );
    }
    else if (completionStep.completion_type == 'form') {
      buttons = [];
      reviewApproveButtons = null;
      typeImage = (
        <FormUpload
          completionStep={completionStep}
          task={task}
          userStepPermissions={userStepPermissions}
          handleCommentsButton={this.handleCommentsButton}
          handleChildCompletionStepUpdate={this.props.handleChildCompletionStepUpdate}
          currentUser={this.props.currentUser}
          isMobile={true}
        />
      );
    }
    else switch (completionStep.requested_file_type) {
    case 'png':
    case 'jpeg':
    case 'jpg':
    case 'gif':
      reviewApproveButtons = null;
      typeImage = (
          <PhotoUpload
            project={project}
            task={task}
            completionStep={completionStep}
            handleCommentsButton={this.handleCommentsButton}
            userStepPermissions={userStepPermissions}
            completionStepStatus={this.props.completionStepStatus}
            switchCS={this.checkSwitchCS}
            handleHandsFreeTaskComplete={this.handleHandsFreeTaskComplete}
            handleChildCompletionStepUpdate={this.props.handleChildCompletionStepUpdate}
            />
        );
      break;
    case 'doc':
    case 'docx':
    case 'dotx':
    case 'dot':
    case 'dotm':
    case 'pdf':
    case 'xls':
    case 'xlt':
    case 'xlm':
    case 'xlsm':
    case 'xlsx':
    case 'xltx':
    case 'mp4':
    case 'mov':
    case 'avi':
    case 'wmv':
    case 'flv':
    case 'Other':
      reviewApproveButtons = null;
      typeImage = (
          <MiscUpload
            userStepPermissions={userStepPermissions}
            project={project}
            task={task}
            completionStep={completionStep}
            handleCommentsButton={this.handleCommentsButton}
            handleChildCompletionStepUpdate={this.props.handleChildCompletionStepUpdate}
            handleFileSelected={this.props.handleFileSelected}
          />
        );
      break;
    default:
      reviewApproveButtons = null;
      typeImage = (
          <MiscUpload
            userStepPermissions={userStepPermissions}
            project={project}
            task={task}
            completionStep={completionStep}
            handleCommentsButton={this.handleCommentsButton}
            handleChildCompletionStepUpdate={this.props.handleChildCompletionStepUpdate}
            handleFileSelected={this.props.handleFileSelected}
          />
        );
      break;
    }

    let buttonList = (
      <div
        className={`button-list ${
          userStepPermissions && userStepPermissions.has('accept/reject') ? 'review-approve' : ''
        }`}
      >
        {buttons}
      </div>
    );

    let displayComponent = typeImage;

    let commentDisplay = null;
    let background = null;

    if (this.props.action == 'comments') {
      buttonList = null;
      displayComponent = (
        <TaskCompletionStepComments
          completionStep={completionStep}
          task={task}
        />
      );
    } else if (this.state.noPhotoRequiredComment) {
      buttonList = null;
      background = <div className="background-disable" />;
      commentDisplay = (
        <div className="comment-input">
          <Textarea
            rows={3}
            className="text-input"
            placeholder="Leave a comment to mark as N/A."
            ref={element => { this.setFocus(element); }}
            onChange={this.handleCommentChange}
            value={this.state.commentText}
            onKeyDown={e => this.handleKeyDown(e, 'na')}
            dataId={completionStep.id}
          />
        </div>
      );
    } else if (this.state.rejectionComment) {
      buttonList = null;
      if (this.props.mobileBridge.isMobile) {
        background = <div className="background-disable" />;
        commentDisplay = (
          <div className="comment-input">
            <Textarea
              rows={3}
              ref={element => {
                this.setFocus(element);
              }}
              className="text-input"
              placeholder="You must leave a comment to reject a Completion Step."
              onChange={this.handleCommentChange}
              value={this.state.commentText}
              onKeyDown={e => this.handleKeyDown(e, 'reject')}
              dataId={completionStep.id}
            />
          </div>
        );
      } else {
        const element = document.getElementById(
          'task-completion-step-comments-' + completionStep.id
        );
        if (element) {
          const rect = element.getBoundingClientRect();
          commentDisplay = (
            <CommentPopup
              task={task}
              completionStep={completionStep}
              height={element.clientHeight}
              width={element.clientWidth}
              left={rect.left}
              top={rect.top - 20}
              type={'REJECTED'}
              commentSent={commentText =>
                this.handleRejectionCommentSent('reject', commentText)
              }
              placeholder={
                'You must leave a comment to reject a Completion Step.'
              }
              cancelComment={this.handleCancelComment}
            />
          );
        }
      }
    }

    let uploadButtons = null;
    let animate = null;

    if (this.state.displayUploadButtons) {
      buttonList = null;
      background = <div className="background-disable" />;

      animate = (
        <Animate
          component_id="upload-buttons"
          key="upload-buttons"
          property={{ bottom: { startVal: -213, endVal: 20 } }}
          duration={250}
        />
      );
      uploadButtons = (
        <div className="upload-options" id="upload-buttons">
          <div className="outerbox" onChange={e => this.handleFileSelect(e)}>
            <div className="upload-button top-button">Upload File </div>
            <input type="file" className="file-input" accept=".png, .jpg, .jpeg" />
            <div className="upload-button">Use Camera </div>
          </div>
          <div className="cancel-button" onClick={this.handleCancelButton}>
            Cancel
          </div>
        </div>
      );
    }
    if (this.state.hideUploadButtons) {
      animate = (
        <Animate
          component_id="upload-buttons"
          key="upload-buttons_hide"
          property={{ bottom: { startVal: 20, endVal: -213 } }}
          duration={250}
          completionCallback={this.handleCloseUpLoadButtons}
        />
      );
    }

    if (this.state.photoSelected) {
      buttonList = null;
    }
    return (
      <div className={'mobile-task-completion-step-info ' + addIn} id={this.props.id}>
        {animate}
        {background}
        {displayComponent}
        {reviewApproveButtons}
        {buttonList}
        {commentDisplay}
        {webInstructions}
        {uploadButtons}
      </div>
    );
  }
}

;

const mapStateToProps = (state) => {
  return {
    dataModel: dataModel,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    mobileBridge: dataModel.mobileBridge,
  };
};

// For handling state change from a dispatch
export default connect(mapStateToProps, null)(
  withRouter(TaskCompletionStepInfoMobile)
);



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/MobileTaskDetails/TaskCompletionStepDetails/TaskCompletionStepInfoMobile/index.js